import { authenticatedInstance } from 'api';

export const LOAD_CURRENCIES = {
  STARTED: 'LOAD_CURRENCIES_STARTED',
  SUCCESS: 'LOAD_CURRENCIES_SUCCESS',
  FAIL: 'LOAD_CURRENCIES_FAIL',
};

export const LOAD_USER_PAYMENT_METHODS = {
  STARTED: 'LOAD_USER_PAYMENT_METHODS_STARTED',
  SUCCESS: 'LOAD_USER_PAYMENT_METHODS_SUCCESS',
  FAIL: 'LOAD_USER_PAYMENT_METHODS_FAIL',
};

export const LOAD_MY_OFFERS = {
  STARTED: 'LOAD_MY_OFFERS_STARTED',
  SUCCESS: 'LOAD_MY_OFFERS_SUCCESS',
  FAIL: 'LOAD_MY_OFFERS_FAIL',
};

export const LOAD_MY_ORDERS = {
  STARTED: 'LOAD_MY_ORDERS_STARTED',
  SUCCESS: 'LOAD_MY_ORDERS_SUCCESS',
  FAIL: 'LOAD_MY_ORDERS_FAIL',
};

export const LOAD_P2PBALANCE = {
  STARTED: 'LOAD_P2PBALANCE_STARTED',
  SUCCESS: 'LOAD_P2PBALANCE_SUCCESS',
  FAIL: 'LOAD_P2PBALANCE_FAIL',
};

export const LOAD_P2PWALLET = {
  STARTED: 'LOAD_P2PWALLET_STARTED',
  SUCCESS: 'LOAD_P2PWALLET_SUCCESS',
  FAIL: 'LOAD_P2PWALLET_FAIL',
};

export const LOAD_PAYMENT_METHODS = {
  STARTED: 'LOAD_PAYMENT_METHODS_STARTED',
  SUCCESS: 'LOAD_PAYMENT_METHODS_SUCCESS',
  FAIL: 'LOAD_PAYMENT_METHODS_FAIL',
};

export const getP2PCurrencies = () => {
  return async (dispatch, getState) => {
    dispatch({ type: LOAD_CURRENCIES.STARTED });
    try {
      const response = await authenticatedInstance({
        url: '/p2p/currencies',
        method: 'GET',
      });

      if (response.data.Status === 'Success') {
        dispatch({
          type: LOAD_CURRENCIES.SUCCESS,
          payload: response.data,
        });
      }
    } catch (e) {
      dispatch({ type: LOAD_CURRENCIES.FAIL });
      // dispatch(triggerToast('somethingWentWrong'));
    }
  };
};

export const getPaymentMethods = () => {
  return async (dispatch, getState) => {
    dispatch({ type: LOAD_PAYMENT_METHODS.STARTED });
    try {
      const response = await authenticatedInstance({
        url: '/p2p/payment-methods',
        method: 'GET',
      });

      if (response.status === 200) {
        dispatch({
          type: LOAD_PAYMENT_METHODS.SUCCESS,
          payload: response.data.Data,
        });
      }
    } catch (e) {
      dispatch({ type: LOAD_PAYMENT_METHODS.FAIL });
      // dispatch(triggerToast('somethingWentWrong'));
    }
  };
};

export const getUserPaymentMethods = () => {
  return async (dispatch) => {
    dispatch({ type: LOAD_USER_PAYMENT_METHODS.STARTED });
    try {
      const { data } = await authenticatedInstance({
        url: '/p2p/get-userpayment-methods',
        method: 'GET',
      });

      if (data.Status === 'Success') {
        dispatch({
          type: LOAD_USER_PAYMENT_METHODS.SUCCESS,
          payload: data.Data,
        });
      } else {
        dispatch({ type: LOAD_USER_PAYMENT_METHODS.FAIL });
      }
    } catch (e) {
      dispatch({ type: LOAD_USER_PAYMENT_METHODS.FAIL });
      // dispatch(triggerToast('somethingWentWrong'));
    }
  };
};

export const getMyOffers = (initilizeValues) => {
  if (!initilizeValues) {
    initilizeValues = {
      Asset: '',
      Side: '',
      Amount: '0',
      DateFrom: '',
      DateTo: '',
      StatusText: '',
    };
  }

  return async (dispatch) => {
    dispatch({ type: LOAD_MY_OFFERS.STARTED });

    try {
      const { data } = await authenticatedInstance({
        url: '/p2p/my-offers',
        method: 'POST',
        data: initilizeValues,
      });

      if (data.Status === 'Success') {
        dispatch({ type: LOAD_MY_OFFERS.SUCCESS, payload: data.Data });
      } else {
        dispatch({ type: LOAD_MY_OFFERS.FAIL });
        // dispatch(triggerToast('somethingWentWrong'));
      }
    } catch (e) {
      dispatch({ type: LOAD_MY_OFFERS.FAIL });
      // dispatch(triggerToast('somethingWentWrong'));
    }
  };
};

export const getMyOrders = () => {
  let initilizeValues = {
    OrderGuid: '',
  };

  return async (dispatch) => {
    dispatch({ type: LOAD_MY_ORDERS.STARTED });

    try {
      const { data } = await authenticatedInstance({
        url: '/p2p/my-orders',
        method: 'POST',
        data: initilizeValues,
      });

      if (data.Status === 'Success') {
        dispatch({ type: LOAD_MY_ORDERS.SUCCESS, payload: data.Data });
      } else {
        dispatch({ type: LOAD_MY_ORDERS.FAIL });
        // dispatch(triggerToast('somethingWentWrong'));
      }
    } catch (e) {
      dispatch({ type: LOAD_MY_ORDERS.FAIL });
      // dispatch(triggerToast('somethingWentWrong'));
    }
  };
};

export const getP2PBalance = (initilizeValues) => {
  if (!initilizeValues) {
    initilizeValues = {
      Currency: 'ALL',
    };
  }

  return async (dispatch) => {
    dispatch({ type: LOAD_P2PBALANCE.STARTED });
    try {
      const { data } = await authenticatedInstance({
        url: '/p2p/balance',
        method: 'POST',
        data: initilizeValues,
      });

      if (data.Status === 'Success') {
        dispatch({ type: LOAD_P2PBALANCE.SUCCESS, payload: data.Data });
      } else {
        dispatch({ type: LOAD_P2PBALANCE.FAIL });
        // dispatch(triggerToast('somethingWentWrong'));
      }
    } catch (e) {
      dispatch({ type: LOAD_P2PBALANCE.FAIL });
      // dispatch(triggerToast('somethingWentWrong'));
    }
  };
};

export const getP2PWallet = () => {
  return async (dispatch) => {
    dispatch({ type: LOAD_P2PWALLET.STARTED });
    try {
      const { data } = await authenticatedInstance({
        url: '/p2p/balances',
        method: 'GET',
      });

      if (data.Status === 'Success') {
        dispatch({ type: LOAD_P2PWALLET.SUCCESS, payload: data.Data });
      } else {
        dispatch({ type: LOAD_P2PWALLET.FAIL });
        // dispatch(triggerToast('somethingWentWrong'));
      }
    } catch (e) {
      dispatch({ type: LOAD_P2PWALLET.FAIL });
      // dispatch(triggerToast('somethingWentWrong'));
    }
  };
};
